// src/Home.js
import './asset/App.css';
import Header from './component/Header';
import React, { useState, useEffect, useRef } from 'react';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Button from '@mui/material/Button';
import html2pdf from 'html2pdf.js';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { DataGrid, GridToolbar, zhTW } from '@mui/x-data-grid';

//创建一个React组件，该组件包含你的HTML模板：
const MyPdfTemplate = () => {
  return (
    <div>
      {/* 这里放置你的HTML模板内容 */}
      <h1>Hello, world!</h1>
    </div>
  );
};

const downloadPdf = () => {
  const element = document.getElementById('pdf-template'); // 获取包含HTML模板的元素
  const options = {
    margin: 10,
    filename: 'my_pdf.pdf', // 下载的文件名
    image: { type: 'jpeg', quality: 0.98 },
    html2canvas: { scale: 2 },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' },
  };

  // 使用html2pdf库将HTML转换为PDF
  html2pdf().from(element).set(options).outputPdf().then((pdf) => {
    // 生成PDF后，创建一个Blob对象并提供下载链接
    const blob = new Blob([pdf], { type: 'application/pdf' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'my_pdf.pdf';
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  });
};

function Home() {

  const [rows, setRows] = useState([]); // 使用状态来存储数据
  const [archiveOpen, setArchiveOpen] = React.useState(false);//作廢popup
  const [archiveForm, setArchiveForm] = React.useState({}); //作廢表單
  const [deleteOpen, setDeleteOpen] = React.useState(false); //刪除表單
  const [deleteForm, setDeleteForm] = React.useState({}); //刪除表單
  const [uploadOpen, setUploadOpen] = React.useState(false);//批量上傳

  const [bulkUpload, setBulkUpload] = React.useState(null);//批量上傳

  //批量上傳
  const navigate = useNavigate();
  const fileInputRef = useRef(null);
  const VisuallyHiddenInput = styled('input')`
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
  const handleUploadClickOpen = () => {
    setUploadOpen(true);
  };
  const handleUploadClose = () => {
    setUploadOpen(false);
  };
  const handleFileChange = (event) => {
    setBulkUpload(event.target.files[0]);
  };

  const handleFileSubmit = (event) => {
    if (bulkUpload) {
      // Perform file upload here
      const formData = new FormData();
      formData.append('file', bulkUpload);

      fetch('https://macct.tw/api/form/bulk_create', {
        method: 'POST',
        headers: {
          'credentials': 'include'
        },
        body: formData,
      })
      .then(response => response.json())
      .then(data => {
        //console.log(data);
        if (data.success) {
          alert("【Beta】批量上傳功能製作中,(共寫入"+data.message.length+"筆)");
          window.location.reload();
        } else {
          alert("勞報單創建失敗 \n \n", data);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }
  };
  
  //作廢popup
  const handleArchiveClickOpen = (data) => {
    setArchiveForm(data);
    setArchiveOpen(true);
  };

  const handleArchiveClose = (check) => {
    if(check){
      //console.log(archiveForm);
      fetch('https://macct.tw/api/form/archive', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify(archiveForm)
      })
      .then(response => response.json())
      .then(data => {
        // 根据返回的数据判断是否已登录
        //console.log("get result:", data);
        if (data.success) {
          alert("勞報單作廢成功");
          setArchiveOpen(false);
          window.location.reload();
        } else {
          alert("勞報單作廢失敗 \n \n", data);
          setArchiveOpen(false);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }else{
      setArchiveForm("");
      setArchiveOpen(false);
    }

  };

  //刪除popup
  const handleDeleteClickOpen = (data) => {
    setDeleteForm(data);
    setDeleteOpen(true);
  };

  const handleDeleteClose = (check) => {
    if(check){
      //console.log(deleteForm);
      fetch('https://macct.tw/api/form/delete', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'credentials': 'include'
        },
        body: JSON.stringify(deleteForm)
      })
      .then(response => response.json())
      .then(data => {
        // 根据返回的数据判断是否已登录
        //console.log("get result:", data);
        if (data.success) {
          alert("勞報單刪除成功");
          setDeleteOpen(false);
          window.location.reload();
        } else {
          alert("勞報單刪除失敗 \n \n", data);
          setDeleteOpen(false);
        }
      })
      .catch(error => {
        console.error('Error:', error);
      });
    }else{
      setDeleteForm("");
      setDeleteOpen(false);
    }

  };
  

  const columnsNew = [
    { field: 'createdAt', headerName: '創立日期', width: 150 },
    { field: 'id', headerName: '編號', width: 150 },
    { field: 'category', headerName: '申報類別', width: 150 },
    { field: 'service', headerName: '勞務內容', width: 150 },
    { field: 'name', headerName: '姓名', width: 100 },
    {
      field: 'price',
      headerName: '金額',
      width: 80,
      align: 'right',
      valueFormatter: (params) => {
        if (params.value == null) {
          return '';
        }
        return `$${params.value.toLocaleString('en-US')}`;
      }
    },
    /*
    { field: 'download', 
      headerName: '紙本下載', 
      width: 120,
      renderCell: (params) => {
        return(      
          <Button variant="contained" color="primary" onClick={() => handlePaperPrint(params.row.id)}>
            下載
          </Button>
      )} 
    },
    { field: 'fee', 
      headerName: '繳費單', 
      width: 120,
      renderCell: (params) => {
        if(params.row.status !== "done"){
          return ("");
        }
        return(    
          <div style={{textAlign:'left'}}>
            <a href="https://eservice.nhi.gov.tw/2nd/" target="_blank">二代健保</a>
            <br></br>
            <a href="https://www.etax.nat.gov.tw/etwmain/etw144w/152" target="_blank">所得稅</a>
          </div>  
      )} 
    },*/
    { field: 'status', 
      headerName: '狀態', 
      width: 120,
      valueGetter: (params) => {
        let status = "";
        switch (params.row.status) {
          case 'pending':
            status = "待確認";
            break;
          case 'done':
            status = "已完成";
            break;
          case 'archive':
            status = "已作廢";
            break;
          case 'draft':
            status = "待對方填寫";
            break;
          case 'deleted':
            status = "已刪除";
            break;
        }
        return status;
      }
    },
  
    { field: 'option', 
      headerName: '選項', 
      width: 100,
      renderCell: (params) => {
        // you will find row info in params
        return(      
          <Button component={Link} to={`/form?id=${params.row.id}`} variant="contained" color="primary">
            查看
          </Button>
      )} 
    },
    { field: 'archive', 
      headerName: '作廢', 
      width: 100,
      renderCell: (params) => {
        //console.log(params.row);
        const data = {id:params.row.id, name:params.row.name, price:params.row.price};
        if(params.row.status != "pending" && params.row.status != "draft"){
          return "";
        }
        return (
          <Button variant="contained" color="error" onClick={() => handleArchiveClickOpen(data)}>
            作廢
          </Button>
        ); 
      } 
    },
    { field: 'delete', 
      headerName: '刪除', 
      width: 100,
      renderCell: (params) => {
        //console.log(params.row);
        const data = {id:params.row.id, name:params.row.name, price:params.row.price};
        if(params.row.status != "archive"){
          return "";
        }
        return (
          <Button variant="contained" sx={{ backgroundColor: 'grey' }} startIcon={<DeleteOutlineOutlinedIcon />} onClick={() => handleDeleteClickOpen(data)}>
            刪除
          </Button>
        ); 
      } 
    }
  ];

  //勞報單資料
  useEffect(() => {
    // 发送请求到 http://masteraccounting.tw:3001/api/login
    fetch('https://macct.tw/api/form/', {
      method: 'GET',
      credentials: 'include' // 保持与后端会话的状态
    })
    .then(response => response.json())
    .then(data => {
      // 根据返回的数据判断是否已登录
      //console.log("get result:", data);
      const rowData = data.forms.map(form => createData(form.createdAt, form.id, form.category, form.service,form.fullName, form.price, "", form.status, "", ""));
      //console.log(rowData);
      setRows(rowData); // 将数据设置到状态中
    })
    .catch(error => {
      console.error('Error:', error);
    });
  }, []); // 使用空数组作为依赖，确保 useEffect 只执行一次

  const handlePaperPrint = () => {
    alert("功能製作中, 待完整版推出");
  };

  //row data to pretty form
  function createData(createdAt, id, category, service, name, price, download, status, option, archive) {
    /*
    download = (
      <Button variant="contained" color="primary" onClick={handlePaperPrint}>
        下載
      </Button>
    );
    option = (
      <Button component={Link} to={`/form?id=${id}`} variant="contained" color="primary">
        查看
      </Button>
    );
    const data = {id:id,name:name,price:price};
    archive = status == "pending" ? (
      <Button variant="contained" color="error" onClick={() => handleArchiveClickOpen(data)}>
        作廢
      </Button>
    ):"";
    */
    return { createdAt, id, category, service, name, price, download, status, option, archive };
  }

  return (
    <div className="App">
      <Header />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '90%', margin: 'auto' }}>
        <Typography variant="h4" sx={{ textAlign: 'left', mt: 3, mb: 3 }}>
          我的勞務報酬單
        </Typography>
        <div>
          {/* ***批量上傳功能暫時隱藏***
            <Button component="label" variant="contained" color="success" sx={{ mr: 1 }} startIcon={<CloudUploadIcon />} onClick={handleUploadClickOpen}>
              批量上傳
            </Button>
          */}
          <Button component={Link} to="/create" variant="contained" color="primary">
            新增勞報單
          </Button>
        </div>
      </div>
       
      <Paper sx={{ width: '90%', overflow: 'hidden', m:"auto" }}>
      <div style={{ height: 900, width: '100%' }}>
        <DataGrid 
          rows={rows} 
          columns={columnsNew} 
          disableColumnSelector
          slots={{ toolbar: GridToolbar }}
          slotProps={{
            toolbar: {
                showQuickFilter: true,
                printOptions: { disableToolbarButton: true },
                csvOptions: { disableToolbarButton: true },
            }
          }}
          localeText={zhTW.components.MuiDataGrid.defaultProps.localeText}
        />
      </div>
      </Paper>
      {/* 作廢視窗 */}
      <Dialog
        open={archiveOpen}
        onClose={handleArchiveClose}
        aria-labelledby="archive-dialog-title"
        aria-describedby="archive-dialog-description"
      >
        <DialogTitle id="archive-dialog-title">
          {"確定要作廢此勞務報酬單?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="archive-dialog-description">
            <div>編號：{archiveForm.id}</div>
            <div>姓名：{archiveForm.name}</div>
            <div>金額：{archiveForm.price}</div>
            <div>注意：一旦作廢將無法回復。</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleArchiveClose(false)}>取消</Button>
          <Button onClick={() => handleArchiveClose(true)} autoFocus>確認</Button>
        </DialogActions>
      </Dialog>
      {/* 刪除視窗 */}
      <Dialog
        open={deleteOpen}
        onClose={handleDeleteClose}
        aria-labelledby="delete-dialog-title"
        aria-describedby="delete-dialog-description"
      >
        <DialogTitle id="delete-dialog-title">
          {"確定要完全刪除此勞務報酬單?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="delete-dialog-description">
            <div>編號：{deleteForm.id}</div>
            <div>姓名：{deleteForm.name}</div>
            <div>金額：{deleteForm.price}</div>
            <div>注意：一旦刪除此勞報單將消失且無法回復。</div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleDeleteClose(false)}>取消</Button>
          <Button onClick={() => handleDeleteClose(true)} autoFocus>確認</Button>
        </DialogActions>
      </Dialog>
      {/* 批量上傳 */}
      <Dialog
        open={uploadOpen}
        onClose={handleUploadClose}
        aria-labelledby="upload-dialog-title"
        aria-describedby="upload-dialog-description"
      >
        <DialogTitle id="upload-dialog-title">
          {"批量上傳勞報單"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="upload-dialog-description">
            <div style={{ marginBottom: '0.5rem' }} >注意：批量上傳作業前，請務必檢查剩餘可用勞報單張數。</div>
            <div>註1：批量上傳功能，目前僅支援<b>本國國籍。</b></div>
            <div>註2：上傳檔案請以CSV檔上傳，保留範例前兩行。</div>
            <div>參考範例：<a href="https://docs.google.com/spreadsheets/d/1wbNQfHyMQDZdYC6YUklOuc83M4YBXpS6kqzDyKYhJ1c/edit?usp=sharing" target="_blank">點此</a></div>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => handleUploadClose()}>取消</Button>
          <Button component="label" variant="contained" color="warning" sx={{ mr: 1 }} startIcon={<CloudUploadIcon />} onClick={() => fileInputRef.current.click()}>
            上傳文件
          </Button>
          <Typography variant="body2" component="span">
            {bulkUpload ? bulkUpload.name : '未選擇文件'}
          </Typography>
          {bulkUpload && (          
            <Button component="label" variant="contained" color="success" sx={{ mr: 1 }} onClick={() => handleFileSubmit()}>
              送出
            </Button>
          )}
          <VisuallyHiddenInput id="file" name="file" type="file" accept=".csv" ref={fileInputRef} onChange={handleFileChange}/>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Home;